const DEFAULT_FORM_DATA = {
  confirm: {},
};

export default DEFAULT_FORM_DATA;
